<div class="notification-wrapper"
     [ngClass]="{'notification-wrapper--products-visible': productsVisible}"
>
    
    <app-notification *ngIf="!notificationService.nextNotification"></app-notification>

    <ng-container *ngIf="notificationService.nextNotification">
        <div *ngIf="!isLoadingMode"
             class="notification-wrapper__content">
            <div class="notification-wrapper__notification" *ngIf="notificationVisible">
                <app-next-notification [title]="notificationData?.title"
                                       [descriptions]="notificationData?.descriptions"
                                       [imageSrc]="notificationData?.imageSrc"
                                       [imageSrcMobile]="notificationData?.imageSrcMobile"
                                       [loading]="notificationData?.loading"
                                       [sessionMessage]="notificationData?.sessionMessage"
                                       [buttonLabel]="notificationData?.buttonLabel"
                                       [cssClassSuffix]="notificationData?.cssClassSuffix"
                                       [code]="notificationData?.code"
                ></app-next-notification>
            </div>

            <div *ngIf="productsVisible"
                 class="notification-wrapper__products main">
                <app-featured-product-tile *ngFor="let product of featuredProducts"
                                           class="notification-wrapper__products__product"
                                           [config]="product"
                ></app-featured-product-tile>
            </div>

            <div *ngIf="footerVisible"
                 class="notification-wrapper__footer">
                <app-footer [featuredProductsAllowed]="notificationData?.footerFeaturedProductsAllowed"
                ></app-footer>
            </div>
        </div>

        <app-spinner class="wizard__spinner" *ngIf="isLoadingMode"></app-spinner>
    </ng-container>
</div>
